import { toast, Toaster } from "sonner";

export { Toaster, toast };
